import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ILogin } from '../shared/interfaces/login.interface';
import { AuthenticationService } from '../core/services/authentication.service';
import { Md5 } from 'ts-md5';
import * as bcrypt from 'bcryptjs';
import { GmsmenuService } from '../core/services/gmsmenu.service';
import { IgmsAlertData } from '../shared/dialogs/gms-alert/gms-alert.component';
import { GmsdialogService } from '../shared/services/gmsdialog.service';
// import { MatDialog } from '@angular/material/dialog';
// import { GmsAlertComponent } from '../shared/dialogs/gms-alert/gms-alert.component';
@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-gms-login',
  templateUrl: './gms-login.component.html',
  styleUrls: ['./gms-login.component.scss']
})
export class GmsLoginComponent implements OnInit {

  loginForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  // private dialog: MatDialog
  constructor(
    private formBuilder: UntypedFormBuilder,
    private acRoute: ActivatedRoute,
    private router: Router,
    private authSer: AuthenticationService,
    private gmsMenuSer: GmsmenuService,
    private gmsDialogSer: GmsdialogService
    //private dialog: MatDialog
  ) {

  }
  ngOnInit () {
    this.authSer.fetchDynaconInfo();
    // const sessionValue = this.authSer.sessionValue;
    // if (sessionValue != "" && sessionValue !== null && sessionValue !== undefined) {
    //   this.router.navigate(['/welcome']);
    // }
    let un = sessionStorage.getItem('userName');
    if (un != "" && un !== null && un !== undefined) {
      this.router.navigate(['/welcome']);
    }

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

  }
  // openDialog(data): void {
  //   const dialogRef = this.dialog.open(GmsAlertComponent, {
  //     width: '250px',
  //     data: data
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed', result);
  //   });
  // }


  get formValues () { return this.loginForm.controls; }

  onSubmit (reqLogin: ILogin) {
    if (this.loginForm.valid) {
      // this.buildGmsMenu();
      // const md5 = new Md5();
      //  var md5Password = md5.appendStr(reqLogin.password).end();
      //   const salt = bcrypt.genSaltSync(10);
      //    var bcriptPass = bcrypt.hashSync(this.loginForm.value.password, salt);
      //var tocheckPassword = bcrypt.compareSync(reqLogin.password, bcriptPass);
      //  console.log("tocheckPassword", tocheckPassword);

      //reqLogin.password = md5Password.toString();//bcriptPass;//md5Password.toString();//bcriptPass;
      this.authSer.login(reqLogin).subscribe((response: any) => {

        this.authSer.userName = reqLogin.username;
        if (response.data) {
          if (response.data.Error) {
            console.log('Erorr:', response.data.Error);
            //this.openDialog({ title: 'Error', message: response.data.Error, buttonText: "close" });
            const data: IgmsAlertData = {
              message: response.data.Error,
              buttonText: 'CLOSE',
              title: "Error"
            };
            this.gmsDialogSer.showAlert(data, "330px");
          } else {
            this.authSer.sessionValue = response.data.session_key;
            if (response.data.Warning == "New password required") {
              this.router.navigate(['/changepassword']);
            } else {
              if (this.authSer.sessionValue) {
                this.gmsMenuSer.buildGmsMenu(response.data.menus_data);
                if (this.authSer.redirectUrl) {
                  this.router.navigateByUrl(this.authSer.redirectUrl);
                } else {
                  this.router.navigate(['/welcome']);
                }
              }
            }
          }

        }
      });
    }
  }



}
// data: { Error: "Invalid login credentials. Please try again" }
// Error: "Invalid login credentials. Please try again"